import { apiInterceptor } from 'utils/apiInterceptor';
export async function createLocation(inputs) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(inputs),
        }
    );
    return await response.json();
}

export async function getLocations(
    projectId,
    page = 1,
    search = '',
    sortOrder = 'asc',
    limit = 10
) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues?projectId=${projectId}` +
            `&page=${page}` +
            `&limit=${limit}` +
            `&search=${search}` +
            `&sortBy=name` +
            `&sortOrder=${sortOrder}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}

export async function getLocation(projectId, locationId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues/${locationId}?projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}

export async function updateLocation(projectId, locationId, inputs) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues/${locationId}?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(inputs),
        }
    );
    return await response.json();
}

export async function deleteLocation(projectId, locationId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues/${locationId}?projectId=${projectId}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}

export async function getSpecificLocations(projectId, locations) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/physical-venues/specific?ids=${locations}&projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}

export async function getLocationsDetails(
    projectId,
    showcaseId,
    date,
    timezone = ''
) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/sessions/locations?showcaseId=${showcaseId}&date=${date}&timezone=${timezone}&projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}